<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
<!-- Новая версия выбора и загрузки изображений и медиа файлов   -->
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="800px">
            <v-card>
                <v-card-title class="pa-0">
                    <media-library-toolbar
                            :model="model"
                            :remove-mode="removeMode"
                            :selected="selected"
                            @updateAllLibrary="updateAllLibrary"
                            @sendNotification="sendNotification"
                            @changeRemoveMode="removeMode = !removeMode"
                            @exitRemoveMode="removeMode = false"
                            @deleteSelectedFiles="confirmDialog = true"
                            @save="save"
                    />
                    <v-tabs vertical>
                        <v-tab v-for="(mediaTypeObject, index) in mediaTypes">
                            <v-flex>
                                <v-badge :overlap="true" bottom left>
                                    <template v-slot:badge>{{mediaItems[index].length}}</template>
                                    <v-icon left large>{{mediaTypeObject.icon}}</v-icon>
                                </v-badge>
                                {{mediaTypeObject.name}}
                            </v-flex>
                        </v-tab>

                        <v-tab-item
                                v-for="(mediaItem, indexMedia) in mediaItems"
                                :key="indexMedia"
                        >
                            <v-layout>
                                <v-flex xs12 sm12>
                                    <v-card max-width="600" class="mx-auto" flat>
                                        <v-container grid-list-sm pa-1>
                                            <v-item-group v-model="selected" multiple>
                                                <v-layout wrap>
                                                    <v-flex
                                                            v-for="(mediaItem, index) in mediaItems[indexMedia]"
                                                            :key="index"
                                                            xs12
                                                            md3
                                                            v-show="mediaItem.show === 1"
                                                    >
                                                        <v-flex v-if="removeMode == false && mediaItem.visible == 1"
                                                                @click="selectMedia(indexMedia, index)">
                                                            <media-file-card :media-item="mediaItem"/>
                                                        </v-flex>
                                                        <v-flex v-if="removeMode == true && mediaItem.visible == 1">
                                                            <media-file-remove-mode-card :media-item="mediaItem"/>
                                                        </v-flex>
                                                    </v-flex>
                                                </v-layout>
                                            </v-item-group>
                                        </v-container>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>
                    </v-tabs>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout>
                        <v-flex xs12>
                            <v-card max-width="750" class="mx-auto" flat>
                                <span>Выбранные файлы:</span>
                                <v-container grid-list-sm pa-1>
                                    <v-layout wrap>
                                        <v-flex
                                                v-for="(selectedItem, index) in selectedItems"
                                                :key="selectedItem.id"
                                                xs2
                                                md2
                                                ma-1
                                        >
                                            <v-badge
                                                    overlap
                                                    v-if="selectedItem.type < 2"
                                                    icon="i"
                                                    title="Информация по медиафайлу"
                                            >
                                                <template v-slot:badge>
                                                    <span class="font-italic font-weight-bold"
                                                          @click="getInfoAttachment(selectedItem)">i</span>
                                                </template>
                                                <v-img
                                                        :src="selectedItem.type === 0 ? selectedItem.link : '/static/video.jpg'"
                                                        height="120"
                                                        width="120"
                                                        class="text-right pa-3"
                                                        @click="selectMedia(null, index, 'deselect')"
                                                ></v-img>
                                                <span class="font-weight-light">{{selectedItem.caption}}</span>
                                            </v-badge>
                                            <v-badge
                                                    overlap
                                                    v-else
                                                    icon="i"
                                                    title="Информация по медиафайлу"
                                            >
                                                <template v-slot:badge>
                                                    <span class="font-italic font-weight-bold"
                                                          @click="getInfoAttachment(selectedItem)">i</span>
                                                </template>
                                                <v-card flat @click="selectMedia(null, index, 'deselect')">
                                                    <v-card-text class="text-truncate pa-1">
                                                        <p class="text-center mb-1">
                                                            <v-icon large>insert_drive_file</v-icon>
                                                        </p>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <span v-on="on">{{selectedItem.caption}}</span>
                                                            </template>
                                                            <span>{{selectedItem.caption}}</span>
                                                        </v-tooltip>
                                                    </v-card-text>
                                                </v-card>
                                            </v-badge>
                                        </v-flex>

                                    </v-layout>
                                </v-container>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="confirmDialog"
                max-width="300"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2">Подтвердите удаление</v-card-title>
                <v-card-text>
                    Вы действительно хотите удалить?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="confirmDialog = false"
                    >
                        Отмена
                    </v-btn>
                    <v-btn
                            color="error darken-1"
                            text
                            @click="removeSelectedMediaItems"
                    >
                        Подтверждаю
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="infoDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="blue lighten-2 white--text">Информация по медиафайлу</v-card-title>
                <v-card-text v-if="infoAttachmentModel != null">
                    <v-row>
                        <v-col class="pa-1">
                            Название файла:
                            <span class="font-weight-bold">{{infoAttachmentModel.caption}}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-1">
                            Загружен:
                            <span class="font-weight-bold">{{createdDate}}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-1">
                            Ссылка:
                            <a class="font-weight-bold" :href="infoAttachmentModel.link" target="_blank">{{infoAttachmentModel.link}}</a>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-1" v-show="infoAttachmentModel.attachmentId.length > 0">
                            id для Вконтакте:
                            <span class="font-weight-bold">{{infoAttachmentModel.attachmentId}}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import axios from 'axios'
import constConf from '../../../constconf.js'

import { mapGetters } from 'vuex'
import MediaFileCard from './media_library/MediaFileCard'
import MediaFileRemoveModeCard from './media_library/MediaFileRemoveModeCard'
import MediaLibraryToolbar from './media_library/MediaLibraryToolbar'
import timeHelpers from '../../../scripts/helpers/timeHelpers'

export default { // новый метод прикреплений. Через таблицу media_bind
    name: 'MediaLibrarySelectBox',
    components: {
        MediaFileCard,
        MediaFileRemoveModeCard,
        MediaLibraryToolbar
    },
    data() {
        return {
            removeMode: false,
            selected: [],
            confirmDialog: false,
            mediaType: 0,
            mediaTypes: [
                { name: 'Картинки', icon: 'photo_library' },
                { name: 'Видео', icon: 'movie' },
                { name: 'Документ', icon: 'insert_drive_file' }
            ],
            mediaItems: [[], [], []],
            selectedItems: [],
            snackbar: false,
            paramsSnackbar: { color: 'success', text: 'Успешно сохранено' },
            binds: {},
            infoDialog: false,
            infoAttachmentModel: null
        }
    },
    props: {
        visible: Boolean,
        model: Object,
        objType: Number
    },
    methods: {
        save() {
            this.$store.dispatch('messages/createMediaBindForModel', {
                files: this.selectedItems,
                model: this.model,
                obj_type: this.objType /* 1 - КАрточки, 2 - сообщения, 3 - рассылки, 4 события */
            }).then(response => {
                if (response.ok) {
                    this.fileBindsToSelectedFiles(response.response.data)
                } else {
                    this.fileBindsToSelectedFiles([])
                }
            })
        },
        selectMedia(typeMedia = null, index, action = 'select') {
            if (action === 'select' && [].concat(...this.selectedItems).length < 10) {
                this.selectedItems.push(this.mediaItems[typeMedia][index])
                this.mediaItems[typeMedia][index].show = 0
            }
            if (action === 'deselect') {
                typeMedia = this.selectedItems[index].type
                for (let i = 0; i < this.mediaItems[typeMedia].length; i++) {
                    if (this.mediaItems[typeMedia][i].id === this.selectedItems[index].id) {
                        this.mediaItems[typeMedia][i].show = 1
                    }
                }
                this.selectedItems.splice(index, 1)
            }
        },
        /**
             * Description: Преобразование объектов связи файлов (fileBinds) в выбранные файлы selectedItems
             * Вызывается при начальной загрузке всех прикрепленных файлов и при сохранении
             **/
        fileBindsToSelectedFiles(fileBinds) {
            this.selectedItems = []
            for (let i = 0; i < 3; i++) {
                for (let j = 0; j < this.mediaItems[i].length; j++) {
                    let show = 1
                    for (let k = 0; k < fileBinds.length; k++) {
                        if (fileBinds[k].file_id === this.mediaItems[i][j].id) {
                            show = 0
                            this.selectedItems.push(this.mediaItems[i][j])
                            break
                        }
                    }
                    this.mediaItems[i][j].show = show
                }
            }
            // Обновление блока с прикрепленными файлами
            this.$emit('updateAttachment', { selectedItems: this.selectedItems, saveModel: false })
        },
        updateMediaInMessage() {
            this.selectedItems = []
            if (this.model.hasOwnProperty('id') && this.model.id) {
                this.$store.dispatch('messages/fileBindAll', { model: this.model, obj_type: this.objType }).then(response => {
                    this.fileBindsToSelectedFiles(response.response.data)
                })
            }
        },
        /**
             * Description: Перезагрузка всех файлов бота
             **/
        updateAllLibrary() {
            this.mediaItems = [[], [], []]
            this.$store.dispatch('messages/fileAll', this.$route.params['pathMatch']).then(response => {
                if (response.ok) {
                    for (let i = 0; i < response.response.data.length; i++) {
                        response.response.data[i].show = 1
                        this.mediaItems[response.response.data[i].type].push(response.response.data[i])
                    }
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Файлы успешно загружены'
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Загрузка файлов прошла с ошибкой'
                    this.snackbar = true
                }
            })
        },
        /**
             * Description: Удаление из сервера выделенных файлов
             **/
        removeSelectedMediaItems() {
            let data = []
            for (let i = 0; i < this.selected.length; i++) {
                data.push(this.mediaItems[this.mediaType][this.selected[i]].id)
                this.mediaItems[this.mediaType][this.selected[i]].visible = 0
            }
            axios.defaults.withCredentials = true
            axios.post(constConf.message.url + '/medialibrary/remove/' + this.$route.params['pathMatch'], data).then(response => {
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
            this.selected = []
            this.confirmDialog = false
        },
        sendNotification() {
            // document.location.href = 'https://vk.com/club' + 173744970
            let bot = this.bot(this.$route.params['pathMatch'])
            let url = 'https://vk.com/gim' + bot.group_id + '?sel=' + this.user.id
            // 'https://vk.com/write-' + bot.group_id, '_blank'
            window.open(url)
            axios.defaults.withCredentials = true
            axios.get(constConf.message.url + '/send/service-vk/' + 1 + '?bot_id=' + bot.id).then(response => {
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
        },
        getInfoAttachment(item) {
            console.log(item)
            this.infoAttachmentModel = item
            this.infoDialog = true
        }
    },
    computed: {
        show: {
            get() {
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        ...mapGetters({
            bot: 'bots/getBotById',
            bots: 'bots/bots',
            user: 'user/user'
        }),
        createdDate() {
            return this.infoAttachmentModel.created_at
                ? timeHelpers.getDateOutUnixTime(this.infoAttachmentModel.created_at) + ' ' +
                    timeHelpers.getTimeOutUnixTime(this.infoAttachmentModel.created_at)
                : ''
        }
    },
    watch: {
        model() {
            this.updateMediaInMessage()
        },
        confirmDialog() {
            if (!this.confirmDialog) {
                this.selected = []
            }
        }
    },
    created() {
        this.updateAllLibrary()
    }
}
</script>

<style scoped>
    a:hover {
        cursor: pointer;
        text-decoration: none;
        color: #000000;
    }
</style>
